import React, { Component } from 'react'
import Layout from './Layout'
import { WithForceLogout } from "KN-Drayage-UI";


class LayoutWrapper extends Component {

    constructor(props) {
        super(props)
       
    }

    componentWillMount() {
        // window._env_ = {
        //     REACT_APP_API_URL: "https://api.klearnow.com/staging-cust/v1/events",
        //     REACT_APP_CHAT_KEY: "368e58ccc62de8c3013d36c5fb9bd3c1d",
        //     ENVIRONMENT: "staging",
        //     REACT_APP_LOGIN_URL_CUSTOMER: "https://customer-staging.klearnow.com",
        //     REACT_APP_LOGOUT_URL_CUSTOMER: "https://cob-staging.klearnow.com",
        //     REACT_APP_LOGOUT_URL_CUSTOMER_WL: "https://jdl-staging.klearnow.com",
        //     KX_K8S_CLUSTER_AWS_REGION: "us-east-1",
        //     KX_S3_ATTACHMENT_URL: "https://kxr-attachments-staging.s3.amazonaws.com",
        //     REACT_APP_CUSTOMER_STRIPE_KEY: "pk_test_Wx9KxRm5f3qFThN7ODhsvLVJ00KDqbnmGf",
        //     REACT_APP_SHIPMENT_MEDIA_URL: "https://api.klearnow.com/staging-ops/v1/upload",
        //     REACT_APP_MEDIA_URL: "https://api.klearnow.com/staging-ops/v1/uploadTo",
        //     CUSTOMER_MEDIA_BUCKET: "kx-customer-media-staging",
        //     TRUCKER_MEDIA_BUCKET: "kx-trucker-media-staging",
        //     SKIP_PREFLIGHT_CHECK: "true",
        //   }
    }

    render() {
        return (
            <Layout />
        )
    }
}

export default WithForceLogout(LayoutWrapper)